export default class TableFields {
  constructor() {
    this.cliente = [
      { key: "nome", label: "Nome", sortable: true },
      { key: "cnpj", label: "CNPJ", sortable: false },
      { key: "cidade", label: "Cidade", sortable: false },
      { key: "uf", label: "UF", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.fornecedor = [
      { key: "nome", label: "Nome", sortable: true },
      { key: "cnpj", label: "CNPJ", sortable: false },
      { key: "cidade", label: "Cidade", sortable: false },
      { key: "uf", label: "UF", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.imagem = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "local", label: "Local", sortable: true },
      { key: "data", label: "data", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.equipamento_print = [
      { key: "sgcq", label: "Sgcq", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "codigo", label: "Codigo", sortable: true },
      { key: "servico", label: "Serviço", sortable: true, thStyle: { width: "44%" } },
    ];

    this.equipamento = [
      { key: "sgcq", label: "Sgcq", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "codigo", label: "Codigo", sortable: true },
      { key: "dimensoes", label: "Dimensões", sortable: true },
      { key: "carga", label: "Carga", sortable: true },
      { key: "referencia", label: "Referência", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.ordemservico = [
      { key: "sgcq", label: "Sgcq", sortable: true },
      { key: "codigo", label: "Codigo", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "servico", label: "Serviço", sortable: true },
      { key: "valor", label: "Valor", sortable: false },
    ];

    this.servico = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "concluido", label: "Concluido", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.orcamento = [
      { key: "id", label: "Id", sortable: true, thStyle: { width: "6%" } },
      { key: "titulo", label: "Título", sortable: false },
      { key: "cliente", label: "Cliente", sortable: true, thStyle: { width: "15%" } },
      { key: "data", label: "Data", sortable: true, thStyle: { width: "10%" } },
      { key: "status", label: "Status", sortable: true, thStyle: { width: "10%" } },
      { key: "total", label: "Total", sortable: false, thStyle: { width: "15%" } },
      { key: "acoes", label: "Ações", sortable: false, thStyle: { width: "6%" } },
    ];

    this.orcamentoItem = [
      { key: "codigo", label: "Código", sortable: false, thStyle: { width: "10%" } },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "unidade", label: "Und", sortable: false, thStyle: { width: "7%" } },
      { key: "quantidade", label: "Qtd", sortable: false, thStyle: { width: "8%" } },
      { key: "valor", label: "Valor", sortable: false, thStyle: { width: "14%" } },
      { key: "total", label: "Total", sortable: false, thStyle: { width: "14%" } },
    ];

    this.faturamento = [
      { key: "id", label: "Id", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "cliente", label: "Cliente", sortable: true },
      { key: "orcamento", label: "Orçamento", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "total", label: "Total", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.faturamentoRelatorio = [
      { key: "id", label: "Id", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "cliente", label: "Cliente", sortable: true },
      { key: "orcamento", label: "Orçamento", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "total", label: "Total", sortable: true },
    ];

    this.produto = [
      { key: "codigo", label: "Código", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "unidade", label: "Unidade", sortable: false },
      { key: "valor", label: "Valor", sortable: false },
      { key: "peso", label: "Peso", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.consumivel = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "fabricante", label: "Fabricante", sortable: false },
      { key: "lote", label: "Lote", sortable: false },
      { key: "data", label: "Data", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.instrumento = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "fabricante", label: "Fabricante", sortable: false },
      { key: "certificado", label: "Certificado", sortable: false },
      { key: "calibracao", label: "Calibração", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.documento = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "numero", label: "Número", sortable: false },
      { key: "tipo", label: "Tipo", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.profissional = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "nome", label: "Nome", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.avulso = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "data", label: "Data", sortable: false },
      { key: "concluido", label: "Concluído", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.atividade = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: false },
      { key: "data", label: "Data", sortable: false },
      { key: "local", label: "Local", sortable: false },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.trabalho = [
      { key: "sgcq", label: "Sgcq", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "codigo", label: "Codigo", sortable: true },
      { key: "servico", label: "Serviço", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.trabalhoPrint = [
      { key: "sgcq", label: "Sgcq", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "codigo", label: "Codigo", sortable: true },
      { key: "servico", label: "Serviço", sortable: true, thStyle: { width: "46%" } },
    ];

    this.armazem = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "codigo", label: "Código", sortable: true },
      { key: "quantidade", label: "Qtd", sortable: true },
      { key: "estado", label: "Estado", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.prioridade = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "solicitante", label: "Solicitante", sortable: true },
      { key: "cliente", label: "Cliente", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.prioridadeItem = [
      { key: "codigo", label: "Código", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "quantidade", label: "Quantidade", sortable: true },
      { key: "atendido", label: "Atendido", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.entrada = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "cliente", label: "Cliente", sortable: true },
      { key: "recebeu", label: "Recebedor", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.entradaItem = [
      { key: "codigo", label: "Código", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "quantidade", label: "Quantidade", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.saida = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "cliente", label: "Cliente", sortable: true },
      { key: "recebeu", label: "Recebedor", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "acoes", label: "Ações", sortable: false, thStyle: { width: "10%" } },
    ];

    this.saidaItem = [
      { key: "codigo", label: "Código", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "quantidade", label: "Quantidade", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.saidaItemProtocolo = [
      { key: "codigo", label: "Código", sortable: true },
      { key: "nome", label: "Nome", sortable: true },
      { key: "quantidade", label: "Quantidade", sortable: true },
    ];

    this.veiculo = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "cor", label: "Cor", sortable: true },
      { key: "placa", label: "Placa", sortable: true },
      { key: "ano", label: "Ano", sortable: true },
      { key: "acoes", label: "Ações", sortable: false, thStyle: { width: "25%" } },
    ];

    this.abastecimento = [
      { key: "id", label: "ID", sortable: true },
      { key: "tipo", label: "Tipo", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "km", label: "Km", sortable: true },
      { key: "quantidade", label: "Qtd", sortable: true },
      { key: "valor", label: "Valor", sortable: true },
      { key: "responsavel", label: "Responsável", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.manutencao = [
      { key: "id", label: "ID", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "km", label: "Km", sortable: true },
      { key: "valor", label: "Valor", sortable: true },
      { key: "responsavel", label: "Responsável", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.abastecimentorRelatorio = [
      { key: "tipo", label: "Tipo", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "km", label: "Km", sortable: true },
      { key: "quantidade", label: "Qtd", sortable: true },
      { key: "valor", label: "Valor", sortable: true },
      { key: "responsavel", label: "Responsável", sortable: true },
    ];

    this.manutencaoRelatorio = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "km", label: "Km", sortable: true },
      { key: "valor", label: "Valor", sortable: true },
      { key: "responsavel", label: "Responsável", sortable: true },
    ];

    this.equipe = [
      { key: "lider", label: "Lider", sortable: true },
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "custo", label: "Custo", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.diario = [
      { key: "atividade", label: "Atividade", sortable: true },
      { key: "alteracao", label: "Alteração", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "km", label: "Km", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.despesa = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "valor", label: "Valor", sortable: true },
      { key: "responsavel", label: "Responsável", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.diarioRelatorio = [
      { key: "atividade", label: "Atividade", sortable: true },
      { key: "alteracao", label: "Alteração", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "km", label: "Km", sortable: true },
    ];

    this.despesaRelatorio = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "data", label: "Data", sortable: true },
      { key: "valor", label: "Valor", sortable: true },
      { key: "responsavel", label: "Responsável", sortable: true },
    ];

    this.certificadoTemplate = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.inspecaoTemplate = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.medicoes = [
      { key: "a", label: "A", sortable: false },
      { key: "b", label: "B", sortable: false },
      { key: "c", label: "C", sortable: false },
      { key: "d", label: "D", sortable: false },
    ];

    this.medicoesTemplate = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.laudosTemplate = [
      { key: "modelo", label: "Modelo", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.checkitens = [
      { key: "item", label: "Item", sortable: false, thStyle: { width: "6%" } },
      { key: "conjunto", label: "Conjunto", sortable: false, thStyle: { width: "25%" }  },
      { key: "descricao", label: "Descrição", sortable: false, thStyle: { width: "55%" }  },
      { key: "laudo", label: "Laudo", sortable: false, thStyle: { width: "14%" }  },
    ];

    this.checklistTemplate = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];

    this.planoManutencaoItens = [
      { key: "intervalo", label: "Intervalo", sortable: false, thStyle: { width: "15%" }  },
      { key: "item", label: "Item", sortable: false, thStyle: { width: "85%" }  },
    ];

    this.planoTemplate = [
      { key: "descricao", label: "Descrição", sortable: true },
      { key: "acoes", label: "Ações", sortable: false },
    ];
  }
}
